jQuery(document).ready(function($) {
    //banner block
    if($('.slider-banner').length > 0) {
        $('.slider-banner').each(function(){
           var attributes = $(this).data("attributes");
           $(this).slick(attributes);
        });
    }
    //special slider block
    if($('.slider-special').length > 0) {
        $('.slider-special').each(function(){
            var attributes = $(this).data("attributes");
            $(this).slick(attributes);
        });
    }
    //monthly slider
    if($('.monthly-slider').length > 0) {
        $('.monthly-slider').each(function(){
            var attributes = $(this).data("attributes");
            $(this).find('ul').slick(attributes);
        });
    }
    //videos scrollbar
    if($(window).width() > 767) {
        if($('.videos-list').length > 0) {
            $(".videos-list").mCustomScrollbar({
                axis:"y"
            });
            $(".why-us").mCustomScrollbar({
               axis:"y"
            });
        }
        if($('.product-description').length > 0) {
            $(".product-description").mCustomScrollbar({
               axis:"y"
            });
        }
        if($('#faqModal .modal-body').length > 0) {
           $("#faqModal .modal-body").height(300);
           $("#faqModal .modal-body").mCustomScrollbar({
              axis:"y"
           });
       }
    }
   /* if($('.search .nav-link').length > 0) {
        $(".search .nav-link").on("click", function(){
            $(".search-form").toggle();
        });
    }*/
    //popular services
    if($('.service-heading').length > 0) {
        $(".service-heading").on("click", function() {
            if ($(window).width() < 1200) {
                $(".services-list").slideToggle();
            }
        });
    }
    if($('.services-list a').length > 0) {
        $(".services-list a").click(function() {
            if ($(window).width() < 1200) {
                $(".services-list").slideToggle();
            }
        });
    }
    if($('.services-list a').length > 0) {
        $('.services-list a').click(function(){
            var getText = $(this).text();
            $('.services-heading').text(getText);
            $('.service-heading').text(getText);
        });
    }

    //cart page
    //quantity
	$(document).on('click', '.plus1', function(){
        var val =  $(this).parent().find('.count1');
        val.focus();
        val.val(parseInt(val.val()) + 1 );
        $("body").trigger('qty_changed',[val]);
	});
    $(document).on('click', '.minus1', function(){
        var val =  $(this).parent().find('.count1');
        val.val(parseInt(val.val()) - 1 );
        val.focus();
        if (val.val() == 0) {
            val.val(1);
        }
        else{
            $( document.body ).trigger('qty_changed',[val]);
        }
	});
   if($('.cart-scroll-controls').length > 0) {
        $('.cart-scroll-controls .nextSlide').click( function(event){
            event.preventDefault();
            $('.table-main').animate({
            scrollLeft: "+=300px"
            }, "slow");
        });
        $('.cart-scroll-controls .prevSlide').click( function(event){
            event.preventDefault();
            $('.table-main').animate({
                scrollLeft: "-=30px"
            }, "slow");
        });
   }
    
    //slider
    if($('.related-services').length > 0) {
        $('.related-services').slick({
            dots: false,
            arrows:true,
            infinite: true,
            speed: 500,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
    if($('.wpcf7-form-control.date').length > 0) {
        $('.wpcf7-form-control.date').mask('00/00/0000');
    }
   if($('.cep').length > 0) {
          $('.cep').mask('00000-000');
    }
    if($('.wpcf7-form-control.wpcf7-mobile').length > 0) {
        var SPMaskBehavior = function (val) {
            return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
        },
        spOptions = {
            onKeyPress: function(val, e, field, options) {
                field.mask(SPMaskBehavior.apply({}, arguments), options);
            }
        };
        $('.wpcf7-form-control.wpcf7-mobile').mask(SPMaskBehavior, spOptions);
    }
    if($('.wpcf7-form-control.wpcf7-cpf').length > 0) {
        $('.wpcf7-form-control.wpcf7-cpf').mask('000.000.000-00', {reverse: true});
    }
    if($('#cpf').length > 0) {
        $('#cpf').mask('000.000.000-00', {reverse: true});
    }
    if($('#birthdate').length > 0) {
        $('#birthdate').mask('00/00/0000');
    }
                        
    //location
    //unit services slider
    if($('.unit-services').length > 0) {
        $('.unit-services').slick({
            dots: false,
            arrows:true,
            infinite: true,
            speed: 500,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    //detail slider
    if($('.detail-slider').length > 0) {
        $('.detail-slider').slick({
            dots: false,
            arrows:true,
            infinite: true,
            speed: 500,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
    //video slider
    if($('.soaking-slider').length > 0) {
        $('.soaking-slider').slick({
            dots: false,
            arrows:true,
            infinite: true,
            speed: 500
        });
    }
    $('.chat a').click(function(){
        window.fcWidget.open();
        //window.fcWidget.show();
    });
   //mini cart
   $("body").on('added_to_cart',function(){
       update_mini_cart();
       if( /Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        window.alert('Produto Adicionado - Ver Carrinho')
       }
   });
   $("body").on('removed_from_cart',function(){
       update_mini_cart();
       if( /Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        window.alert('Produto Removido - Ver Carrinho')
       }
   });
   $("body").on('updated_wc_div',function(){
       update_mini_cart();
       new LazyLoad();
   });
    $("body").on('qty_changed', function(){
        var update = jQuery(':input[name="update_cart"]');
        if(update.length >0){
            update.removeAttr("disabled").attr("clicked","true").trigger('click');
        }
    });
});


function update_mini_cart(){
  jQuery.get(wp.ajax_url, {action: "update_min_cart"}, function(data){
        jQuery(".nav-item.bag").html(data);
    });
}

jQuery('[data-toggle="tooltip"]').tooltip();
